import React from "react";

export type MessageAuthorArgs = {
  id: string;
  name: string;
  imageUrl?: string;
  deleted?: boolean;
};

export default function MessageAuthor({
  id,
  name,
  imageUrl,
}: MessageAuthorArgs) {
  return (
    <div className="chatMessageAuthor flex gap-2 items-center">
      {imageUrl && (
        <img
          className="chatMessageImage h-5 w-5 rounded-full"
          alt={name}
          src={imageUrl}
        />
      )}
      <a className={"grow text-sm font-semibold"} href={`/members/${id}`}>
        {name}
      </a>
    </div>
  );
}
